// src/components/ui/illustrations/CalendarEmpty.tsx
// The muted calendar-and-clock drawing for an empty schedule — the Dashboard's
// "No upcoming appointments for today" (docs/design/dashboard, region 8).
// Decorative only (aria-hidden); the sentence beside it carries the meaning.
// Colours come from tokens via Tailwind fill/stroke classes, no hex.
import { cn } from '@/lib/cn';

export function CalendarEmpty({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 110 62" aria-hidden className={cn('shrink-0', className)}>
      <ellipse cx="55" cy="57" rx="48" ry="4" className="fill-muted" />
      <path d="M14 56c0-10 3-16 6-18M20 56c0-7-2-12-5-14M92 56c0-9 3-14 5-16M96 56c0-6 2-10 5-12" className="fill-none stroke-control-line" strokeWidth="2" />
      <rect x="32" y="8" width="44" height="40" rx="4" className="fill-card stroke-control-line" strokeWidth="1.6" />
      <rect x="32" y="8" width="44" height="9" rx="4" className="fill-muted" />
      <path d="M41 4v8M67 4v8" className="stroke-control-line" strokeWidth="2" strokeLinecap="round" />
      <g className="fill-muted">
        <rect x="37" y="21" width="7" height="5" rx="1" /><rect x="47" y="21" width="7" height="5" rx="1" /><rect x="57" y="21" width="7" height="5" rx="1" />
        <rect x="37" y="29" width="7" height="5" rx="1" /><rect x="47" y="29" width="7" height="5" rx="1" /><rect x="37" y="37" width="7" height="5" rx="1" />
      </g>
      <circle cx="73" cy="42" r="10" className="fill-card stroke-control-line" strokeWidth="1.6" />
      <path d="M73 36v6l4 2" className="fill-none stroke-control-line" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
